/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-function-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  useFocusEffect,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import 'dayjs/locale/fr';
import React, {useCallback, useState} from 'react';
import {ScrollView, View} from 'react-native';
import {connect} from 'react-redux';
import {initModalData} from '../../../../../data/constants/Assurance/AssuranceRapatriement/souscription';
import {ApiResponse} from '../../../../../data/types/interface/api';
import {
  DevisRapatriementParam,
  DevisRapatriementResponse,
} from '../../../../../data/types/interface/Assurance/AssuranceRapatriement/devis';
import {ModalDataDTO} from '../../../../../data/types/interface/Assurance/AssuranceVoyage/souscription';
import {StackParams} from '../../../../../data/types/navigation';
import {RapatriementServices} from '../../../../../services/applicatif/rapatriement';
import mapDispatchToProps from '../../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../../components/Header/HeaderScreen';
import {Loader} from '../../../../components/Loader';
import ConfirmationModal from '../../../../components/Modal/ConfirmationModal';
import FormDevis from './FormDevis';
import {Result} from './Result';

type NavigationProps = StackNavigationProp<StackParams, 'DemanderDevis'>;

export function DemanderDevisAssuranceRapatriementScreen() {
  const {goBack} = useNavigation<NavigationProps>();
  const {params}: any = useRoute();
  const {postDevis} = RapatriementServices();

  const [isLoading, setLoading] = useState(false);
  const [defaultData, setDefaultData] = useState<DevisRapatriementParam[]>([]);
  const [beneficiaire, setBeneficiaire] = useState<DevisRapatriementParam[]>(
    [],
  );

  const [modalData, setModalData] = React.useState<ModalDataDTO>({
    ...initModalData,
  });

  const [resultDevis, setResultDevis] =
    useState<DevisRapatriementResponse | null>(null);

  const handleSubmit = (values: DevisRapatriementParam[]) => {
    console.log('devisParam', values);
    setBeneficiaire(() => values);

    setLoading(true);
    postDevis(values)
      .then((res: ApiResponse<DevisRapatriementResponse>) => {
        console.log(res);

        if (!res?.isError && res.data) {
          setResultDevis(() => res.data);
        } else {
          setModalData({
            status: true,
            title: 'Erreur',
            content: res.message,
            btn1: 'OK',
            btn2: undefined,
            handleBtn1: () => setModalData({...initModalData}),
            handleBtn2: undefined,
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useFocusEffect(
    React.useCallback(() => {
      // setDataDto(() => ({
      //   // TODO: add default values
      //   assured: [],
      //   type: [],
      // }));
    }, [params]),
  );

  const resetResultDevis = useCallback(() => {
    setResultDevis(() => null);
    setDefaultData(() => beneficiaire);
  }, [beneficiaire]);

  return (
    <View style={{flex: 1}}>
      <HeaderScreen
        title="Assurance obsèques à dago"
        type="ChangeScreen"
        action={() => {
          if (resultDevis) {
            resetResultDevis();
          } else {
            goBack();
          }
        }}
        noBreadcrumb={false}
      />
      {modalData.status && (
        <ConfirmationModal
          title={modalData.title}
          content={modalData.content}
          btn1={modalData.btn1}
          btn2={modalData.btn2}
          handleBtn1={modalData.handleBtn1}
          handleBtn2={modalData.handleBtn2}
        />
      )}
      {isLoading ? <Loader /> : null}
      {!isLoading ? (
        <View>
          {resultDevis ? (
            <ScrollView>
              <Result
                data={resultDevis}
                beneficiaires={beneficiaire}
                // user={user}
                onCancel={resetResultDevis}
              />
            </ScrollView>
          ) : (
            <FormDevis
              onCancel={goBack}
              onSubmit={(data: any) => {
                handleSubmit(data);
              }}
              defaultData={defaultData}
            />
          )}
        </View>
      ) : null}
    </View>
  );
}
export const DemanderDevisAssuranceRapatriement: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DemanderDevisAssuranceRapatriementScreen);
